import React from 'react';
import type {
    RealestateAd,
    RealestateProjectAd,
    SearchKey,
} from '../../../types';
import type { BaseSearchAdProps } from '../SearchAdTypes';
import { BasicRealestateSearchAd } from './BasicRealestateSearchAd';
import { PlussRealestateSearchAd } from './PlussRealestateSearchAd';
import { PremiumRealestateSearchAd } from './PremiumRealestateSearchAd';

type RealestateSearchAdProps = BaseSearchAdProps & {
    ad: RealestateAd | RealestateProjectAd;
    basicImageSizes?: string;
    plussImageSizes?: string;
    premiumImageSizes?: string;
    searchKey: SearchKey;
    secondaryImageWidth?: number;
};

export function RealestateSearchAd(props: RealestateSearchAdProps) {
    const {
        ad,
        basicImageSizes,
        plussImageSizes,
        premiumImageSizes,
        searchKey,
        secondaryImageWidth,
    } = props;

    const format = getFormat(ad, searchKey);

    if (format === 'premium') {
        return (
            <PremiumRealestateSearchAd
                imageSizes={premiumImageSizes}
                {...props}
            />
        );
    } else if (format === 'pluss') {
        return (
            <PlussRealestateSearchAd
                imageSizes={plussImageSizes}
                secondaryImageWidth={secondaryImageWidth}
                {...props}
            />
        );
    } else {
        return (
            <BasicRealestateSearchAd imageSizes={basicImageSizes} {...props} />
        );
    }
}

function getFormat(
    ad: RealestateAd | RealestateProjectAd,
    searchKey: SearchKey,
): 'premium' | 'pluss' | 'basic' {
    const isLettings = searchKey === 'SEARCH_ID_REALESTATE_LETTINGS';

    if (ad.flags?.includes('highlight_listing_estate_premium')) {
        return 'premium';
    }
    if (ad.flags?.includes('highlight_listing_estate_pluss') || isLettings) {
        return 'pluss';
    }
    return 'basic';
}
